import { useEffect } from 'react'
import { Toast } from '@heroui/react'

import { AppProviders } from '@/providers'
import { AppRoutes } from '@/routes'
import { useAuthStore } from '@/features/auth'

function SessionBootstrap() {
  const bootstrap = useAuthStore((state) => state.bootstrap)

  // The access token is memory-only, so every load re-mints one from the
  // persisted refresh token before any protected route renders.
  useEffect(() => {
    void bootstrap()
  }, [bootstrap])

  return null
}

export default function App() {
  return (
    <AppProviders>
      <SessionBootstrap />
      <AppRoutes />
      <Toast.Provider placement="bottom end" />
    </AppProviders>
  )
}
